<bb-page-header [icon]="'bars-staggered'" [title]="'AD_SCHEDULES' | translate" [filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<bb-adstats-blocks [adScheduleStats]="adScheduleStats?.cumulative_stats || {}" [hideInView]="true"></bb-adstats-blocks>

<div class="body-column">
	<div class="options">
		<div class="action-buttons">
			<a class="button" [routerLink]="['/adservices/adschedule', 'new', 'metadata']"><i class="fa fa-plus"></i>
				<span class="short-label">{{ 'CREATE_NEW' | translate }}</span>
				<span class="long-label">{{ 'CREATE_NEW_AD_SCHEDULE' | translate }}</span>
			</a>
		</div>
	
		<bb-date-presets
			(onChanged)="datesChanged($event)"
			[icon]="'line-chart'"
			[presets]="adServicesService.datePresets"
			[time]="true"
			[isLoading]="downloadingReport"
		>
			<a footer class="button download feedback" download (click)="downloadFromUrl()">
				<i class="fa fa-line-chart"></i>
				{{ 'DOWNLOAD_STATISTICS' | translate }}
			</a>
		</bb-date-presets>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="playoutCodes">{{ 'PLAYOUTS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="preroll">{{ 'PREROLL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="midroll">{{ 'MIDROLL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="postroll">{{ 'POSTROLL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="inventory">{{ 'INVENTORY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="views">{{ 'IMPRESSIONS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell [hideSorting]="true" property="placementRate">{{ 'PLACEMENT_RATE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createddate">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row" (dblclick)="redirectToDetails(row.id)">
			<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
			<bb-table-cell property="title" class="overflow">{{ row.data.title }}</bb-table-cell>
			<bb-table-cell property="playoutCodes" class="overflow">{{ row.data.playoutCodes }}</bb-table-cell>
			<bb-table-cell property="preroll" class="small">
				<span *ngIf="row.data.preroll?.items[0]?.vast_url" class="fa fa-check"></span>
			</bb-table-cell>
			<bb-table-cell property="midroll" class="small">
				<span *ngIf="row.data.midroll?.items[0]?.vast_url" class="fa fa-check"></span>
			</bb-table-cell>
			<bb-table-cell property="postroll" class="small">
				<span *ngIf="row.data.postroll?.items[0]?.vast_url" class="fa fa-check"></span>
			</bb-table-cell>
			<bb-table-cell property="status">
				<span [innerHTML]="row.data | statusIcon"></span>
			</bb-table-cell>
			<bb-table-cell property="inventory"><span [innerHTML]="row?.inventory"></span></bb-table-cell>
			<bb-table-cell property="views"><span [innerHTML]="row?.views"></span></bb-table-cell>
			<bb-table-cell property="placementRate"><span [innerHTML]="row?.placementRate"></span></bb-table-cell>
			<bb-table-cell optional property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">
				{{ row.data.createddate | bbDate:'relative' }}
			</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}
			</bb-table-cell>
			<bb-table-cell optional property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">
				{{ row.data.updateddate | bbDate:'relative' }}
			</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">
				{{ row.data.updatedBy }}
			</bb-table-cell>
			<bb-table-cell class="row-actions buttons" (click)="$event.stopPropagation()">
				<!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/adservices/adschedule', row.data.id, 'metadata']">
					<i class="fa fa-edit"></i>
				</a>

				<a class="button root" [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>
			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="!rows?.length">{{ 'NO_AD_SCHEDULES_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>
</div>
